import { render, staticRenderFns } from "./GStudentRecordRecommendationLetterPolicySelectionStep.vue?vue&type=template&id=dbf2960a&scoped=true&"
import script from "./GStudentRecordRecommendationLetterPolicySelectionStep.vue?vue&type=script&lang=ts&"
export * from "./GStudentRecordRecommendationLetterPolicySelectionStep.vue?vue&type=script&lang=ts&"
import style0 from "./GStudentRecordRecommendationLetterPolicySelectionStep.vue?vue&type=style&index=0&id=dbf2960a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbf2960a",
  null
  
)

export default component.exports